import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';
import { EndasureEmailComponent } from '../endasure-email/endasure-email.component';
import { ViewportScroller } from '@angular/common';
import { Subject, take, takeUntil } from 'rxjs';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';

@Component({
  selector: 'app-endasure-summary',
  templateUrl: './endasure-summary.component.html',
  styleUrls: ['./endasure-summary.component.scss'],
  standalone: false
})
export class EndasureSummaryComponent {
  tableData: any[];
  private readonly destroy$ = new Subject<void>();
  constructor(public endasureService: EndasureService, private readonly cdr: ChangeDetectorRef,
    private readonly matdialog: MatDialog, private readonly viewPortScroller: ViewportScroller,
    private globalmsgService: GlobalMessageService,
  ) {
    this.endasureService.TableCalculation();
  }
  endurasureSummaryForm = new FormGroup({});
  get form() {
    return this.endurasureSummaryForm.controls;
  }


  endaSureBack() {
    this.endasureService.currentComponent$.next('endurasurePro');
    this.cdr.detectChanges();
  }
  ngOnInit() {

    this.endasureService.summaryData$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.tableData = x;
      this.cdr.detectChanges();
    })

  }
  emailPopup() {
    this.viewPortScroller.scrollToPosition([0, 0]);
    this.matdialog.open(EndasureEmailComponent).afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result?.status === 'Success') {
          this.globalmsgService.add(
            { key: result.message },
            GlobalMessageType.MSG_TYPE_INFO
          );
        }
      });
  }
  resetForms() {
    this.endasureService.triggerReset();
    this.endasureService.currentComponent$.next('visitorInfo');
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }

}
